import React, { Fragment } from 'react';

export const Footer = props => {
    return (
        <Fragment>
            
        </Fragment>
    )
}